import * as React from 'react';
import { connect } from 'react-redux';
import { IKioskThemes } from '../../../models/utilitiesModel';
import { kioskRefreshTimeUpdate, setkioskIdAndGetTokensDataRequest, setResetForKioskStartTimeAndEndTime } from '../../../store/actions';
import './../Kiosk.css';
import { SuperParentContext } from './kioskcontext';
import {
    EmiratesIdVerification,
    MrnVerfication,
    PatientJouneyExistPage,
    PatientJouneyExplore,
    ThemeOneAppointmentsList,
    ThemeOneErrorBlock,
    ThemeOneFooter,
    ThemeOneHome,
    ThemeOneKioskContainer,
    ThemeOneKioskManager,
    ThemeOneTime,
    ThemeOneTokenGeneration,
    ThemeOneTopBar,
    ThemeOneVerificationMode,
    PageLoading,
    FirstpassHome
} from './kioskindex';
import Loading from './loading';


let subscribe;

class Kiosk extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            themeOne: {
                ThemeOneHome: ThemeOneHome,
                ThemeOneFooter: ThemeOneFooter,
                ThemeOneKioskManager: ThemeOneKioskManager,
                ThemeOneTopBar: ThemeOneTopBar,
                MrnVerfication: MrnVerfication,
                EmiratesIdVerification: EmiratesIdVerification,
                ThemeOneAppointmentsList: ThemeOneAppointmentsList,
                ThemeOneErrorBlock: ThemeOneErrorBlock,
                ThemeOneTokenGeneration: ThemeOneTokenGeneration,
                ThemeOneVerificationMode: ThemeOneVerificationMode,
                ThemeOneTime: ThemeOneTime,
                PatientJouneyExplore: PatientJouneyExplore,
                PatientJouneyExistPage: PatientJouneyExistPage,
                PageLoading:PageLoading,
                FirstpassHome:FirstpassHome
            }
        }
    }
    render() {
        return (
            <>
                <SuperParentContext.Provider value={this.state.themeOne}>
                    <ThemeOneKioskContainer theme={IKioskThemes.THEME1} />
                </SuperParentContext.Provider>
                <Loading />
            </>
        );
    }
}
export default connect(null, { setkioskIdAndGetTokensDataRequest, kioskRefreshTimeUpdate, setResetForKioskStartTimeAndEndTime })(Kiosk); 
